import {List} from "@app/core/lists/domain/list";
import {ProductMapper} from "@app/core/product/infrastructure/mappers/product.mapper";

export class ListMapper {
    static deserialize(param: any): List {
        return new List({
            id: param.id,
            code: param.code,
            name: param.name,
            image: param.image,
            products: param.products.map(ProductMapper.deserialize),
            totalPrice: param.total_price
        });
    }
}
